var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"options":_vm.options,"size":_vm.size,"state":_vm.inputState},scopedSlots:_vm._u([(_vm.showFirst)?{key:"first",fn:function(){return [_c('option',{domProps:{"value":null}},[_vm._v(" - ")])]},proxy:true}:null],null,true),model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }